import React, { useEffect, useState } from "react";

import { PiTelevisionDuotone } from "react-icons/pi";
import { FcReadingEbook } from "react-icons/fc";
import { FaJediOrder } from "react-icons/fa";
import { fetchEvaluation } from "../../api/Evaluation";
import EditorRenderer from "../EditorRenderer";

const Mission = () => {
    const [evaluation, setEvaluation] = useState([]);
    const [parsedBlocks, setParsedBlocks] = useState([]);
  
    useEffect(() => {
      const getEvaluation = async () => {
        const data = await fetchEvaluation();
        setEvaluation(data);
      };
      getEvaluation();
    }, []);
  
   const evaluationFilter = evaluation.filter(
      (item) => item.category?.name.toLowerCase() === "vission&mission"
    );
  
  useEffect(() => {
    if (!parsedBlocks.length && evaluationFilter.length) {
      let blocksArray = [];
      try {
        const raw = evaluationFilter[0]?.description;
        if (raw) {
          const outer = JSON.parse(raw);
          const inner = outer[0];
          if (inner?.blocks && Array.isArray(inner.blocks)) {
            blocksArray = inner.blocks;
          }
        }
      } catch (err) {
        console.error("Parsing error:", err);
      }
  
      setParsedBlocks(blocksArray);
    }
  }, [evaluationFilter, parsedBlocks.length]);


  return (
    <div className="flex flex-col gap-4">
      <h1 className="sm:text-3xl text-2xl font-bold text-[#22BEFF] mt-[3rem] mb-[2rem]">
        রূপকল্প ও অভিলক্ষ্য (VISION & MISSION)
      </h1>

       {parsedBlocks.length > 0 && <EditorRenderer blocks={parsedBlocks} />}

     
      
    </div>
  );
};

export default Mission;
